module.exports = __webpack_public_path__ + "static/media/IMG_20191128_171651.3e3f7a61.jpg";